// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__TX2xA","header":"ReportDetails_header__2k6On","title":"ReportDetails_title__36R1k","left":"ReportDetails_left__DIFlX"};